import AudioDescribed from 'assets/icons/audio-described.svg'
import React from 'react'
import { filterAudioDescriptionClick } from 'frontend/utils/analytics/dataLayerDispatchers'
import Toggle, { ToggleEnableState } from './Toggle/Toggle'
import { SearchParams } from 'backend/services/types/urApiService.types'

interface AudioDescriptionProps {
  isInModal?: boolean
  interactiveState: ToggleEnableState
  onClick: () => void
  searchParams: SearchParams
}

const AudioDescription = ({
  isInModal,
  interactiveState,
  onClick,
  searchParams,
}: AudioDescriptionProps) => {
  const ariaLabel = `Syntolkat, ${
    searchParams.is_audio_described ? 'vald' : 'ej vald'
  }`

  return (
    <Toggle
      isInModal={isInModal}
      ariaLabel={ariaLabel}
      dataTrk="filter-audio-described"
      interactiveState={interactiveState}
      onClick={() => {
        filterAudioDescriptionClick(
          searchParams.is_audio_described ? 'off' : 'on',
        )
        onClick()
      }}
      selected={searchParams.is_audio_described || false}
    >
      <>
        <AudioDescribed aria-hidden focusable="false" />
        Syntolkat
      </>
    </Toggle>
  )
}

export default AudioDescription
